var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4541 17.6665V22.4897H0.506836V17.6665H10.4541ZM22.4902 10.3872V22.4868H13.3848V10.3872H22.4902ZM1.04883 21.9478H9.91113V18.2085H1.04883V21.9478ZM13.9268 21.9448H21.4512V21.4448H21.9482V10.9302H13.9268V21.9448ZM10.4541 10.3872V15.2114H0.506836V10.3872H10.4541ZM1.04883 14.6694H9.91113V10.9302H1.04883V14.6694ZM22.4697 0.510254V7.47314H0.506836V0.510254H22.4697ZM1.04883 6.93115H21.9277V1.05225H1.04883V6.93115Z",
    fill: "#3D3C42",
    stroke: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmTemplate);
export default __webpack_public_path__ + "static/media/assessm_template.efbd9026df378530a17d9d694126c86b.svg";
export { ForwardRef as ReactComponent };